import { useOs } from '@mantine/hooks'

export function useIsMobileDevice() {
  const os = useOs()

  return !!(os === 'android' || os === 'ios')
}
